import { render, staticRenderFns } from "./CardTarjaMundialDeClubesFifa.vue?vue&type=template&id=0f9a7e2d&scoped=true"
import script from "./CardTarjaMundialDeClubesFifa.vue?vue&type=script&lang=js"
export * from "./CardTarjaMundialDeClubesFifa.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaMundialDeClubesFifa.vue?vue&type=style&index=0&id=0f9a7e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a7e2d",
  null
  
)

export default component.exports